import * as React from 'react';
import { Button, CheckboxWithHint, Modal } from '@ixicare/ui';
import { t } from '~i18n';
import { Spacer } from '~components/Utils/Spacer';

interface Props {
  currentInterval: string;
  onCancel: () => void;
  onConfirm: (stopGpsFixes: boolean) => void;
}

/**
 * The outdoor alarm raised how often the watch takes a position, and turning the alarm off does not
 * lower it again - nothing here knows what the watch was doing beforehand, so it cannot be put back.
 * Which way that should land depends on the resident, not on anything the form can infer, so it is
 * asked once, at the save that causes it.
 *
 * Unticked by default: a flat battery is the cheaper mistake than a wearer who cannot be located.
 */
const StopGpsFixesModal: React.FC<Props> = ({ currentInterval, onCancel, onConfirm }) => {
  const [stopGpsFixes, setStopGpsFixes] = React.useState(false);

  return (
    <Modal onClose={onCancel} center>
      <h3 className="text-center mb-10">{t('profile-configuration.geofence.stopGps.title')}</h3>
      <p className="mb-15">{t('profile-configuration.geofence.stopGps.body', { interval: currentInterval })}</p>
      <Spacer size={32} />
      <CheckboxWithHint
        id="stop-gps-fixes"
        tone="warning"
        label={t('profile-configuration.geofence.stopGps.clearLabel')}
        hint={t('profile-configuration.geofence.stopGps.clearHint')}
        checked={stopGpsFixes}
        onCheckedChange={setStopGpsFixes}
      />
      <Spacer size={32} />
      <Button
        className="mb-15"
        isBlock
        type="button"
        buttonType={stopGpsFixes ? 'error' : 'primary'}
        onClick={() => onConfirm(stopGpsFixes)}
      >
        {t(
          stopGpsFixes
            ? 'profile-configuration.geofence.stopGps.confirmStop'
            : 'profile-configuration.geofence.stopGps.confirmKeep'
        )}
      </Button>
      <Button isBlock buttonType="link" type="button" onClick={onCancel}>
        {t('global.cancel')}
      </Button>
    </Modal>
  );
};

export default StopGpsFixesModal;
